import { ChangeDetectionStrategy, Component, input, Input, OnInit } from '@angular/core';
import { UtilityService } from '@Services/utility.service';
import { IMenuItem, MenuItem } from '@Shared/models/IMenuItem';


import { TranslatePipe } from '../../../../Shared/pipes/translate.pipe';

import { MenuItemsComponent } from '../menu-items/menu-items.component';
import { SvgIconComponent } from '../../../../Shared/components/svg-icon/svg-icon.component';
import { MatMenuModule } from '@angular/material/menu';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    MatMenuModule,
    SvgIconComponent,
    MenuItemsComponent,
    RouterLink,
    AsyncPipe,
    TranslatePipe
]
})
export class MenuItemComponent {
  readonly menuItem = input<MenuItem>();
}
